var exports = {
  "p": "CreateIssueContainer__oab6KN",
  "Y": "LoadingContainer__GfMPpc",
};

module.exports = exports;
